module.exports = __webpack_public_path__ + "img/jh.0fa49a01.jpg";